module.exports = __webpack_public_path__ + "img/gloriainsta.ab06ec48.jpg";